import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NoAuthComponent } from './no-auth/no-auth.component';
import { ReLoginComponent } from './re-login/re-login.component';

@NgModule({
  imports: [
    CommonModule
  ],
  declarations: [NoAuthComponent, ReLoginComponent]
})
export class AccessGuardModule { }
